import { Navigate } from "react-router-dom";
import type { ReactElement } from "react";

interface AdminGuardProps {
  children: ReactElement;
}

export default function AdminGuard({ children }: AdminGuardProps) {
  // ตรวจสอบว่า user เป็น admin หรือไม่
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const isAdmin = user.is_admin || false;

  console.log("AdminGuard: Checking admin access", { user: user.email, isAdmin });

  // TODO: ชั่วคราวให้ทุกคนเข้าได้เพื่อทดสอบ - จะแก้ไขภายหลัง
  // if (!isAdmin) {
  //   console.log("AdminGuard: Access denied, redirecting to login");
  //   return <Navigate to="/login" replace />;
  // }

  // ชั่วคราว: ถ้าไม่มี user เลยให้ไป login
  if (!user.email) {
    console.log("AdminGuard: No user found, redirecting to login");
    return <Navigate to="/login" replace />;
  }

  return children;
}
